export default () => {
  return window.localStorage.getItem('language')
}
